import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './choice.module.css';

/** A native select dressed like the panel's fields; `options` are `{ value, label }`, values strings or numbers. */
export const SelectField = ({ label, options, value, onChange }) => {
    const isNumeric = typeof options[0]?.value === 'number';
    return (
        <span className={styles.selectField}>
            <select
                className={styles.select}
                aria-label={label}
                value={value}
                onChange={(event) => onChange(isNumeric ? Number(event.target.value) : event.target.value)}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </select>
            <ExpandMoreIcon className={styles.selectArrow} aria-hidden="true" />
        </span>
    );
};
